import { render, staticRenderFns } from "./GrantsResource.vue?vue&type=template&id=2fa99535&scoped=true&"
import script from "./GrantsResource.vue?vue&type=script&lang=js&"
export * from "./GrantsResource.vue?vue&type=script&lang=js&"
import style0 from "./GrantsResource.vue?vue&type=style&index=0&id=2fa99535&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa99535",
  null
  
)

export default component.exports